import { format } from 'date-fns';
import { getUTCDate } from '@utilities/date';

type Timestamp = number | null;

export const calcFormattedLastUpdatedTimestamp = (
  revenueTimestamp: Timestamp = null,
  incomeTimestamp: Timestamp = null
) => {
  const lastUpdatedTimestamp = Math.max(
    revenueTimestamp || 0,
    incomeTimestamp || 0
  );

  // Instead of showing January 1, 1970, we show the n/a
  if (lastUpdatedTimestamp === 0) {
    return 'n/a';
  }

  return format(getUTCDate(lastUpdatedTimestamp), 'dd MMM yyyy');
};
